function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.991,
    height: 23.004,
    viewBox: "0 0 25.991 23.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.52,15.21l-1.8-1.81V8.94A6.86,6.86,0,0,0,12.9,2.06,6.74,6.74,0,0,0,5.28,8.73V13.4l-1.8,1.81A1.64,1.64,0,0,0,4.64,18H8v.34A3.84,3.84,0,0,0,12,22a3.84,3.84,0,0,0,4-3.66V18h3.36a1.64,1.64,0,0,0,1.16-2.79ZM14,18.34A1.88,1.88,0,0,1,12,20a1.88,1.88,0,0,1-2-1.66V18h4ZM5.51,16l1.18-1.18a2,2,0,0,0,.59-1.42V8.73A4.73,4.73,0,0,1,8.9,5.17,4.67,4.67,0,0,1,12.64,4a4.86,4.86,0,0,1,4.08,4.9v4.5a2,2,0,0,0,.58,1.42L18.49,16Z",
    transform: "translate(-3.009 -2.002)",
    fill: props.fill
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.991)",
    style: {
      fill: "#f54b2a",
      stroke: "#f54b2a",
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7,
    style: {
      stroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.fe5e9fcff66a93321d4e8cd689d2b269.svg";
export { ForwardRef as ReactComponent };